import { AutofillMonitor } from '@angular/cdk/text-field';
import { AsyncPipe } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicFormModel } from '@ng-dynamic-forms/core';
import { CsAgentAuthService } from '@spartacus/asm/root';
import {
  AuthService,
  AuthStorageService,
  BaseSiteService,
  CmsService,
  GlobalMessageConfig,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
} from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData, SiteContextType } from '@spartacus/storefront';
import { CookieService } from 'ngx-cookie';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, combineLatest, throwError } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { AuthRedirectStorageService } from 'src/app/service/auth/auth-redirect-storage.service';
import { ShimanoAuthRedirectService } from 'src/app/service/auth/shimano-auth-redirect.service';
import { ShimanoBusinessTypeService } from 'src/app/service/businessType/shimano-business-type.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { FLAG_ICON, MyaccountFeaturesConfigService } from 'src/app/service/myaccount/myaccount-features-config.service';
import { SiteContextService } from 'src/app/service/site-context/site-context.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { TNCPayload } from 'src/app/service/terms-and-conditions/terms-and-conditions.service';
import { LoginService } from 'src/app/service/user/login.service';
import { RequestAccountService } from 'src/app/service/user/request-account.service';
import { BaseSiteConfigService } from '../../../../service/base-site/base-site-config.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../asm/asm-constant';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [AsyncPipe],
  standalone: false,
})
export class LoginComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input() context: SiteContextType;
  data$: Observable<any[]> = this.componentData.data$;
  signinForm: FormGroup;
  submitted = false;
  configuration$: Observable<any>;
  businnesTypes: Array<any> = [];
  countries: Array<any> = [];
  languages: Array<any> = [];
  language: any;
  sub: Subscription;
  siteCode: string;
  err: boolean;
  hidePassword = true;
  hasRequested = 'false';
  formGroup: FormGroup;
  formModel: DynamicFormModel;
  header = document.querySelector('header');
  globalMsg = document.querySelector('cx-global-message');
  userLanguage = this.cookieService.get('userLanguage');
  userCountry = this.cookieService.get('userCountry');
  errorMsg: any;
  businessTypeSelected: any;
  countrySelected: any;
  selectedCountry: any;
  langSelected: any;
  countryIndex: any;
  langIndex: any;
  payload: TNCPayload = { userId: '' };
  tncVersion: any;
  tncAcceptedDate: any;
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  isMobile = false;
  cxMobileWidth = this.breakpointService.getSize(BREAKPOINT.sm);
  rightContentSlot: any;
  autofilled = false;
  userDetails: string;
  labels: any;
  selections: any;
  selectionsAll: any;
  @ViewChild('emailAddr', { static: false }) emailAddr: ElementRef;
  @ViewChild('passwordField', { static: false }) passwordField: ElementRef;

  siteContextSubscription$: Subscription;
  siteContextBaseSite: string;
  siteContextBusinessType: string;
  siteContextCountry: string;
  siteContextLanguage: string;
  siteContextUrl: string;
  requestAccountUrl: string;
  isEmailFocused: boolean = false;
  isPasswordFocused: boolean = false;

  redirectFromLoginSubscription: Subscription;
  requestAccountSubscription: Subscription;
  requestAccountEnabled: boolean;
  requestAccountUrlSubscription: Subscription;
  fieldSubscription$: Subscription;

  dropdownIsOpened = false;
  countryDropdownIsOpened = false;

  activeCountry$: Observable<string> = this.countryService.getActive();
  activeLanguage$: Observable<string> = this.activeLanguage.getActive();
  activeBusinessType$: Observable<string> = this.businessTypeService.getActive();
  shimanoNewEmailRegex: string;

  isCountryFlagIconEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, FLAG_ICON)
    )
  );

  currentCountry = this.pipeAsync.transform(this.activeCountry$);

  storeFrontPermissionsSubscription$: Subscription;
  srpDisplayed: boolean;

  constructor(
    protected componentData: CmsComponentData<any>,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private auth: AuthService,
    private globalMessageService: GlobalMessageService,
    private cookieService: CookieService,
    private routingService: RoutingService,
    private breakpointService: BreakpointService,
    private asmAuthService: CsAgentAuthService,
    private shimanoLanguageService: ShimanoLanguageService,
    private cdr: ChangeDetectorRef,
    private globalMessageConfig: GlobalMessageConfig,
    private cmsService: CmsService,
    private autofillMonitor: AutofillMonitor,
    private countryService: ShimanoCountryService,
    private activeLanguage: ShimanoLanguageService,
    private businessTypeService: ShimanoBusinessTypeService,
    private baseSiteService: BaseSiteService,
    private componentService: ComponentService,
    private authRedirectService: ShimanoAuthRedirectService,
    private authRedirectStorageService: AuthRedirectStorageService,
    private requestAccountService: RequestAccountService,
    private myaccountFeaturesConfigSerivce: MyaccountFeaturesConfigService,
    private pipeAsync: AsyncPipe,
    private authStorageService: AuthStorageService,
    private siteContextService: SiteContextService,
    private baseSiteConfigService: BaseSiteConfigService,
    private storageService: StorageService,
    private deviceDetectorService: DeviceDetectorService,
    private renderer: Renderer2
  ) {
    this.cmsService.getCurrentPage().subscribe((currentPage) => {
      if (currentPage && currentPage.template.includes('LoginPageTemplate')) {
        this.globalMessageConfig.globalMessages['[GlobalMessage] Error'].timeout = undefined;
        this.globalMsg.removeAttribute('class');
      } else {
        this.globalMessageConfig.globalMessages['[GlobalMessage] Error'].timeout = 7000;
      }
    });
  }

  ngOnInit() {
    this.getEmailRegex$().subscribe((data) => (this.shimanoNewEmailRegex = data));
    this.siteContextSubscription$ = combineLatest([
      this.auth.isUserLoggedIn(),
      this.baseSiteService.getActive(),
      this.businessTypeService.getActive(),
      this.countryService.getActive(),
      this.shimanoLanguageService.getActive(),
    ]).subscribe(([isUserLoggedIn, baseSite, businessType, country, language]) => {
      if (!isUserLoggedIn) {
        this.siteContextBaseSite = baseSite;
        this.siteContextBusinessType = businessType;
        this.siteContextCountry = country;
        this.siteContextLanguage = language;
        this.siteCode = businessType;
        this.loadSelections();
      }
    });
    this.storageService.removeLocalStorageItem('shimanoSessionB2BUnit');
    this.storageService.removeLocalStorageItem('shimanoSessionB2BUnit_enabled');
    this.storageService.removeLocalStorageItem('shimanoSessionB2BUnit_multiple');
    this.storageService.removeLocalStorageItem('shimanoSessionB2BUnitname');
    this.storageService.setLocalStorageitem('initLoginPage', 'true');
    this.isMobile = window.innerWidth < this.cxMobileWidth;
    this.rightContentSlot = document.querySelector('.RightContentSlot');

    if (this.f === 'true') {
      this.hasRequested = this.f;
    } else {
      this.pageChange('false');
    }

    if (this.storageService.getSessionStorageItem('showSrp') === 'true') {
      this.storageService.setLocalStorageitem('showSrp', 'true');
      this.storageService.removeSessionStorageItem('showSrp'); //remove showSRP in sessionStorage
    }

    this.signinForm = this.formBuilder.group({
      email: ['', [Validators.pattern(this.shimanoNewEmailRegex), Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      country: ['', [Validators.required]],
      language: ['', [Validators.required]],
      showSrpToggle: this.storageService.getLocalStorageItem('showSrp') === 'true',
    });

    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);

    this.componentService.isPageLoadedFromLogin$.next(false);
    this.isRequestAccountEnabled();
    this.getRequestAccountUrl();
    this.storageService.removeSessionStorageItem('pageLoadedFromLogin');
  }

  isRequestAccountEnabled = () => {
    this.requestAccountSubscription = this.getRequestAccountConfig$().subscribe((requestAccount) => {
      if (requestAccount === undefined) {
        this.requestAccountEnabled = true;
      } else {
        this.requestAccountEnabled = requestAccount === 'true';
      }
      this.cdr.detectChanges();
    });
  };
  getRequestAccountUrl = () => {
    this.requestAccountUrlSubscription = this.getRequestAccountUrlConfig$().subscribe((requestAccountUrl) => {
      this.requestAccountUrl = requestAccountUrl;
      if (requestAccountUrl === undefined) {
        this.requestAccountUrl = '';
      }
      this.cdr.detectChanges();
    });
  };

  loadRegionConfigValues(regionConfigData?: any, type: any = null) {
    this.countries = [];
    this.languages = [];
    this.businnesTypes = [];
    this.labels = regionConfigData.labels;
    this.selections = regionConfigData.selections;

    const currentBusinnesType = this.siteContextBusinessType.toUpperCase(); //get the current business type
    //GET the businesType dropdown
    if (regionConfigData.labels.businessTypes.length > 0) {
      this.businnesTypes = regionConfigData.labels.businessTypes;
    }
    //Assign the business type selected
    this.businessTypeSelected = currentBusinnesType;
    this.storageService.setSessionStorageItem('businessTypeSelected', this.businessTypeSelected);

    //GET the list on active business type
    let countries = regionConfigData.selections.filter((data: any) => data.code === currentBusinnesType)[0].countries;
    let copyCountries = JSON.parse(JSON.stringify(countries)); //clone to use to add the name attribute

    let languages = regionConfigData.selections.filter((data: any) => data.code === currentBusinnesType)[0].countries;
    languages = languages.map((item: any) => item.languages);

    let copyLanguages = JSON.parse(JSON.stringify(languages)); //clone to use to add the name attribute

    // ADD the name for country
    countries.forEach((country: any, index: any) => {
      const checkCountry = this.labels.countries.filter((data: any) => data.code === country.code);
      if (checkCountry.length > 0) {
        copyCountries[index].name = checkCountry[0].label;
      }
    });

    // ADD the name for language
    languages.forEach((lang: any, pIndex: any) => {
      const parentindex = pIndex;
      lang.forEach((item: any, cIndex: any) => {
        const childIndex = cIndex;
        const getLangName = this.labels.languages.filter((data: any) => data.code === item.code);
        if (getLangName.length > 0) {
          copyLanguages[parentindex][childIndex].name = getLangName[0].label;
        }
      });
    });

    //FINAL OUTPUT
    this.countries = copyCountries.map((elem: any) => {
      elem.isocode = elem.code;
      delete elem.code;
      return elem;
    });

    this.languages = copyLanguages.map((data: any) =>
      data.map((elem: any) => {
        elem.isocode = elem.code;
        delete elem.code;
        return elem;
      })
    );

    //Check or Set the country selected. Fallback to true if not exist or first index
    if (this.countrySelected === null || this.countrySelected === undefined || type !== null) {
      this.countrySelected = this.siteContextCountry.toUpperCase();
      const checkCountryExist = this.countries.filter((data) => data.isocode === this.countrySelected);

      if (checkCountryExist.length <= 0) {
        const getDefault = this.countries.filter((data) => data.fallback === true);
        if (getDefault.length > 0) {
          this.countrySelected = getDefault[0].isocode; // get default country
        } else {
          this.countrySelected = this.countries[0].isocode; // get first index if no fallback is set to true
        }
        this.signinForm.controls.country.setValue(this.countrySelected);
        this.countryService.setActive(this.countrySelected.toLowerCase());
      }
      this.storageService.setSessionStorageItem('countrySelected', this.countrySelected);
    }

    //Check or Set the language selected. Fallback to true if not exist or first index
    const getIndex = this.countries.findIndex((c) => c.isocode === this.countrySelected);
    this.langSelected = this.siteContextLanguage;
    const checkLangExist = this.languages[getIndex].filter((data: any) => data.isocode === this.langSelected);
    if (checkLangExist.length <= 0) {
      const getDefault = this.languages[getIndex].filter((data: any) => data.fallback === true);
      if (getDefault.length > 0) {
        this.langSelected = getDefault[0].isocode; // get default language
      } else {
        this.langSelected = this.languages[getIndex].isocode; // get first index if no fallback is set to true
      }
      this.shimanoLanguageService.setActive(this.langSelected);
    }

    //Load the items
    this.loadLanguagesDropdown(getIndex);
    this.loadCountriesDropdown(getIndex);
  }

  loadSelections() {
    this.siteContextService
      .getSelections$(this.siteContextLanguage)
      .pipe(
        take(1),
        tap((types) => {
          this.selectionsAll = types;
          this.loadRegionConfigValues(this.selectionsAll);
        })
      )
      .subscribe();
  }

  getBusineessTypeActiveLabel() {
    if (this.businnesTypes.length > 0) {
      return this.businnesTypes.filter((data) => data.code === this.businessTypeSelected)[0].label;
    }
    return;
  }

  getRegionConfig$(): Observable<any> {
    return this.loginService.getConfigurations();
  }

  selectCountry(event: any): void {
    this.selectedCountry = event.name;
    this.countrySelected = event.isocode;
    this.signinForm.controls.country.setValue(this.countrySelected);
    this.storageService.setSessionStorageItem('countrySelected', this.countrySelected);
    this.countryService.setActive(this.countrySelected.toLowerCase());

    const index = this.countries.findIndex((c) => c.isocode === this.countrySelected);
    this.loadLanguagesDropdown(index);
    const langExist = this.languages[index].filter((lang: any) => lang.isocode === this.langSelected).length;

    if (langExist > 0) {
      this.selectLang(null, this.langSelected);
    } else {
      if (this.languages[index] && this.languages[index][0] && this.languages[index][0].isocode) {
        this.langSelected = this.languages[index][0].isocode;
        this.selectLang(null, this.langSelected);
      }
    }
    location.reload();
    this.isRequestAccountEnabled();
    this.getRequestAccountUrl();
  }

  selectBusinessType(btype: any): void {
    const type = btype.code.toLowerCase();
    this.businessTypeService.setActive(type);
    this.loadRegionConfigValues(this.selectionsAll, 'btype');
    this.cmsService.refreshLatestPage();
    location.reload();
  }

  loadLanguagesDropdown(countrySelectedIndex: number) {
    this.language = this.languages[countrySelectedIndex];
  }
  loadCountriesDropdown(countrySelectedIndex: number) {
    let countrySelected = this.countries[countrySelectedIndex];
    this.selectedCountry = countrySelected.name;
    this.signinForm.patchValue({ country: countrySelected.isocode });
  }

  selectLang(event: any, defaultLanguage: any = null): void {
    this.langIndex = event ? event.source.selected._element.nativeElement.id : 0;
    this.shimanoLanguageService.setActive(event ? event.value : defaultLanguage);
    this.updateRedirectUrl();
    this.loadRegionConfigValues(this.selectionsAll);
  }

  updateRedirectUrl() {
    this.authRedirectStorageService
      .getRedirectUrl()
      .pipe(take(1))
      .subscribe((redirectUrl) => {
        let newRedirectUrl: string;
        if (redirectUrl && redirectUrl !== 'global') {
          const indexOfBusinessType = redirectUrl.indexOf('/', 0);
          const indexOfCountry = redirectUrl.indexOf('/', indexOfBusinessType + 1);
          const _redirectUrl = this.replaceAt(redirectUrl, indexOfBusinessType + 1, this.siteContextCountry);
          newRedirectUrl = this.replaceAt(_redirectUrl, indexOfCountry + 1, this.siteContextLanguage);
        } else {
          newRedirectUrl = [this.siteContextBusinessType, this.siteContextCountry, this.siteContextLanguage]
            .join('/')
            .toLowerCase();
        }
        this.authRedirectStorageService.setRedirectUrl(newRedirectUrl);
      });
  }

  replaceAt(str: string, index: number, replacement: string) {
    return str.substring(0, index) + replacement + str.substring(index + replacement.length);
  }

  login(): void {
    const { email, password, country, language, showSrpToggle } = this.signinForm.controls;
    this.setStorageData(showSrpToggle);
    this.storageService.setLocalStorageitem('selectedLanguageOnLogin', language.value);

    this.userDetails =
      this.asmEnabled && email.status.toUpperCase() === 'VALID'
        ? email.value
        : [this.siteContextBusinessType, country.value, email.value].join(':');

    if (this.isMobile) {
      this.errorMsg = document.querySelector('.login-global-message');
      this.errorMsg.setAttribute('style', 'display:block;');
    }

    if (this.asmEnabled === 'true') {
      this.asmAuthService.authorizeCustomerSupportAgent(
        this.userDetails.toLowerCase(),
        encodeURIComponent(password.value)
      );

      this.sub = this.authStorageService.getToken().subscribe((userToken) => {
        if (userToken && userToken.access_token) {
          this.storageService.setLocalStorageitem('asmUserId', this.userDetails);
          this.routingService.go({
            cxRoute: 'dealerSelection',
          });
          this.storageService.setSessionStorageItem('pageLoadedFromLogin', 'true');
        }
        this.cdr.detectChanges();
      });
    } else {
      this.auth.loginWithCredentials(this.userDetails.toLowerCase(), encodeURIComponent(password.value));
      this.sub = this.authStorageService.getToken().subscribe((userToken) => {
        if (userToken && userToken.access_token) {
          this.storageService.setLocalStorageitem('fromLoggedIn', 'true');
        }
        this.cdr.detectChanges();
      });
    }
  }

  setStorageData(showSrpToggle: any) {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.storageService.removeLocalStorageItem('initLoginPage');
    this.cookieService.put('countryIndex', this.countryIndex);
    this.cookieService.put('langIndex', this.langIndex);
    this.storageService.setLocalStorageitem('showSrp', showSrpToggle.value);
  }

  get isRequestAccountEnabled$(): Observable<boolean> {
    return this.activeCountry$.pipe(
      take(1),
      switchMap((activeCountry) => this.requestAccountService.isRequestAccountEnabled(activeCountry))
    );
  }

  getRequestAccountConfig$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.request.account.enabled'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.request.account.enabled')
              .map((res: any) => res.value)[0]
        )
      );
  }

  getRequestAccountUrlConfig$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.request.account.url'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.request.account.url')
              .map((res: any) => res.value)[0]
        )
      );
  }

  @HostListener('window:resize')
  contentResize() {
    if (this.rightContentSlot.scrollHeight > window.innerHeight && !this.deviceDetectorService.isTablet()) {
      this.rightContentSlot.classList.remove('right-content-full-height');
    } else {
      this.rightContentSlot.classList.add('right-content-full-height');
    }
  }

  onFocus(field: string) {
    const el = field === 'email' ? this.emailAddr.nativeElement : this.passwordField.nativeElement;
    if (el && this.autofilled) {
      this.renderer.setProperty(el, 'value', el.value);
    }
  }

  ngAfterViewChecked() {
    this.contentResize();
    if (this.rightContentSlot.scrollHeight < window.innerHeight) {
      this.rightContentSlot.classList.add('right-content-full-height');
    }

    /* login and password auto filled */
    setTimeout(() => {
      const emailField$ = this.autofillMonitor.monitor(this.emailAddr);
      const passwordField$ = this.autofillMonitor.monitor(this.passwordField);

      this.fieldSubscription$ = combineLatest([emailField$, passwordField$]).subscribe(([emailEvent, passEvent]) => {
        this.autofilled = emailEvent.isAutofilled || passEvent.isAutofilled;

        if (this.autofilled) {
          window.dispatchEvent(new Event('resize'));
          this.cdr.detectChanges();
        }
      });
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  checkRememberMe(model: string, value: string) {
    return model ? '' : value;
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.siteContextSubscription$) {
      this.siteContextSubscription$.unsubscribe();
    }
    if (this.redirectFromLoginSubscription) {
      this.redirectFromLoginSubscription.unsubscribe();
    }
    if (this.requestAccountSubscription) {
      this.requestAccountSubscription.unsubscribe();
    }
    if (this.requestAccountUrlSubscription) {
      this.requestAccountUrlSubscription.unsubscribe();
    }

    this.fieldSubscription$?.unsubscribe();
    this.autofillMonitor.stopMonitoring(this.emailAddr);
    this.autofillMonitor.stopMonitoring(this.passwordField);
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  requestAccount(hasRequested: any, url: any): void {
    const requestAccount = hasRequested;
    const requstUrl = url;
    if (requstUrl === '') {
      this.storageService.setLocalStorageitem('hasRequested', requestAccount);
      this.shimanoLanguageService.setActive(this.langSelected);
      this.pageChange('true');
      window.location.reload();
    }
  }

  pageChange(pageStatus: any) {
    this.storageService.setLocalStorageitem('pageChange', pageStatus);
  }

  onOpenDropdown(event: any) {
    this.dropdownIsOpened = event;
  }

  countryOnOpenDropdown(event: any) {
    this.countryDropdownIsOpened = event;
  }

  onCountrySelection(event: any) {
    if (event.isocode) {
      this.signinForm.patchValue({ country: event.isocode });
    }
  }

  selectedCountryName(countrySelectedIndex: number): string {
    let countrySelected = this.countries[countrySelectedIndex];
    return countrySelected.name;
  }

  isCountrySnah(): boolean {
    if (this.siteContextCountry === 'ca' || this.siteContextCountry === 'us') {
      return true;
    } else {
      return false;
    }
  }

  get f() {
    return this.storageService.getLocalStorageItem('hasRequested');
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth < this.cxMobileWidth;
  }

  goToForgotPassword(): void {
    this.componentService.isPageLoadedFromLogin$.next(true);
  }

  getEmailRegex$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.email.regex'])
      .pipe(
        map(
          (configs: any[]) =>
            configs &&
            configs.filter((config: any) => config.key === 'shimano.email.regex').map((res: any) => res.value)[0]
        )
      );
  }
}
